'use client';

import { ReactNode } from 'react';
import { MdCheckCircle, MdError, MdInfo } from 'react-icons/md';
import { createToaster, Portal, Spinner, Stack, Toast, Toaster as ChakraToaster, Tokens } from '@chakra-ui/react';

import { Status } from '../../../types';

export const toaster = createToaster({
  placement: 'top',
  pauseOnPageIdle: true,
});

function getToastIconColor(type: string | undefined): Tokens['colors'] {
  switch (type) {
    case Status.SUCCESS:
      // eslint-disable-next-line i18next/no-literal-string -- color token not user facing text
      return 'green.fg';
    case Status.WARNING:
      // eslint-disable-next-line i18next/no-literal-string -- color token not user facing text
      return 'orange.fg';
    case Status.ERROR:
      // eslint-disable-next-line i18next/no-literal-string -- color token not user facing text
      return 'red.fg';
    default:
      // eslint-disable-next-line i18next/no-literal-string -- color token not user facing text
      return 'blue.fg';
  }
}

function getToastIcon(type: string | undefined): ReactNode {
  switch (type) {
    case Status.SUCCESS:
      return <MdCheckCircle />;
    case Status.WARNING:
      return <MdError />;
    case Status.ERROR:
      return <MdError />;
    default:
      return <MdInfo />;
  }
}

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {(toast) => (
          <Toast.Root width={{ md: 'sm' }}>
            {toast.type === 'loading' ? (
              <Spinner size="sm" color="blue.solid" />
            ) : (
              <Toast.Indicator color={getToastIconColor(toast.type)}>
                {toast.type ? getToastIcon(toast.type) : <MdInfo />}
              </Toast.Indicator>
            )}
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
            </Stack>
            {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
            {toast.meta?.closable && (
              <Toast.CloseTrigger width={3.5} color="gray.fg" position="absolute" right={2} top={2} />
            )}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
};
